import { render, staticRenderFns } from "./StaffDocuments.vue?vue&type=template&id=3f8efc1c&"
import script from "./StaffDocuments.vue?vue&type=script&lang=js&"
export * from "./StaffDocuments.vue?vue&type=script&lang=js&"
import style0 from "./StaffDocuments.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports